import React from 'react';
import { Link } from 'react-router-dom';

const Landing = () => {
  return (
    <div style={styles.container}>
      <div style={styles.hero}>
        <div style={styles.content}>
          <h1 style={styles.title}>Mike's Pest Patrol</h1>
          <p style={styles.subtitle}>
            Professional pest control services for residential and commercial properties.
          </p>
          <p style={styles.description}>
            Protecting homes and businesses from unwanted pests with safe, effective,
            and reliable treatments. Serving our community with expert technicians
            and proven methods.
          </p>
          <div style={styles.services}>
            <div style={styles.serviceCard}>
              <h3 style={styles.serviceTitle}>Residential</h3>
              <p style={styles.serviceText}>
                Keep your home pest-free with regular treatments tailored to your property.
              </p>
            </div>
            <div style={styles.serviceCard}>
              <h3 style={styles.serviceTitle}>Commercial</h3>
              <p style={styles.serviceText}>
                Protect your business with comprehensive pest management solutions.
              </p>
            </div>
          </div>
          <div style={styles.ctaSection}>
            <Link to="/login" style={styles.loginButton}>
              Employee Login
            </Link>
          </div>
        </div>
      </div>
      <footer style={styles.footer}>
        <p style={styles.footerText}>
          Mike's Pest Patrol &mdash; Professional Pest Control Services
        </p>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  hero: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
  },
  content: {
    maxWidth: '800px',
    width: '100%',
    textAlign: 'center',
    color: 'white',
  },
  title: {
    fontSize: '3rem',
    fontWeight: '700',
    marginBottom: '1rem',
    textShadow: '0 2px 4px rgba(0,0,0,0.2)',
  },
  subtitle: {
    fontSize: '1.25rem',
    fontWeight: '300',
    marginBottom: '1.5rem',
    opacity: 0.95,
  },
  description: {
    fontSize: '1rem',
    lineHeight: '1.6',
    marginBottom: '2.5rem',
    opacity: 0.9,
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  services: {
    display: 'flex',
    gap: '1.5rem',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '2.5rem',
  },
  serviceCard: {
    background: 'rgba(255,255,255,0.15)',
    borderRadius: '12px',
    padding: '1.5rem 2rem',
    minWidth: '220px',
    maxWidth: '300px',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.2)',
  },
  serviceTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    marginBottom: '0.5rem',
  },
  serviceText: {
    fontSize: '0.9rem',
    lineHeight: '1.5',
    opacity: 0.9,
    margin: 0,
  },
  ctaSection: {
    marginTop: '1rem',
  },
  loginButton: {
    display: 'inline-block',
    background: 'white',
    color: '#667eea',
    padding: '0.875rem 2.5rem',
    borderRadius: '8px',
    fontSize: '1.1rem',
    fontWeight: '600',
    textDecoration: 'none',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
  footer: {
    textAlign: 'center',
    padding: '1.5rem',
    borderTop: '1px solid rgba(255,255,255,0.15)',
  },
  footerText: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: '0.875rem',
    margin: 0,
  },
};

export default Landing;
